import React from 'react';
import { Alert, Box, Grid, Paper, Stack, Typography } from '@mui/material';

type Props = {
  title?: string;
  subtitle?: string;
  masterTitle?: string;
  detailTitle?: string;
  master: React.ReactNode;
  detail?: React.ReactNode;
  selected?: any;
  emptyDetailMessage?: string;
  vertical?: boolean;
};

class FComboGridPanel extends React.PureComponent<Props> {
  render() {
    const p = this.props;
    const vertical = p.vertical ?? true;
    const detailContent = p.selected || p.detail ? p.detail : (
      <Paper elevation={1} sx={{ p: 2 }}>
        <Alert severity="info">{p.emptyDetailMessage || 'Select a parent row to display related detail records.'}</Alert>
      </Paper>
    );

    return (
      <Stack spacing={2}>
        {(p.title || p.subtitle) && (
          <Box>
            {p.title && <Typography variant="h6" sx={{ fontWeight: 800 }}>{p.title}</Typography>}
            {p.subtitle && <Typography variant="body2" color="text.secondary">{p.subtitle}</Typography>}
          </Box>
        )}

        {vertical ? (
          <Stack spacing={2}>
            <Box>{p.masterTitle && <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700 }}>{p.masterTitle}</Typography>}{p.master}</Box>
            <Box>{p.detailTitle && <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700 }}>{p.detailTitle}</Typography>}{detailContent}</Box>
          </Stack>
        ) : (
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, lg: 6 }}>{p.masterTitle && <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700 }}>{p.masterTitle}</Typography>}{p.master}</Grid>
            <Grid size={{ xs: 12, lg: 6 }}>{p.detailTitle && <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700 }}>{p.detailTitle}</Typography>}{detailContent}</Grid>
          </Grid>
        )}
      </Stack>
    );
  }
}

export default FComboGridPanel;
